import { render, staticRenderFns } from "./PrestataireList.vue?vue&type=template&id=3f895c35&scoped=true&"
import script from "./PrestataireList.vue?vue&type=script&lang=js&"
export * from "./PrestataireList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f895c35",
  null
  
)

export default component.exports